@import './dynamic-table.rtl.less';
@import './igws-live-prices.less';

.dynamic-table {
  [data-field] {
    margin-right: 15px;
  }

  [data-field$='BID'],
  [data-field$='OFR'] {
    padding-left: 16px;

    &:after {
      left: 0;
    }

    &.price--up {
      &:after {
        background-position: center left;
      }
    }

    &.price--down {
      &:after {
        background-position: center right;
      }
    }
  }
}
